
import { Link } from "react-router-dom";
import { CaseStudyCard } from "./CaseStudyCard";
import { caseStudies } from "@/data/caseStudyData";

export const SuccessStoriesSection = () => {
  // Get the first two featured case studies
  const featuredCaseStudies = caseStudies.filter(study => study.featured).slice(0, 2);

  return (
    <section id="success-stories" className="py-16" aria-labelledby="success-stories-heading">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 
          id="success-stories-heading" 
          className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl text-center mb-4"
        >
          From Chaos to Growth: Client Transformations
        </h2>
        
        <p className="text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">
          Discover how we've helped organizations strengthen their security posture and accelerate business growth.
        </p>
        
        <div className="grid grid-cols-1 gap-8 mb-8">
          {featuredCaseStudies.map((study, index) => (
            <CaseStudyCard key={index} {...study} />
          ))}
        </div>
        
        <div className="text-center">
          <Link 
            to="/case-studies" 
            className="inline-flex items-center gap-2 text-edgefi-purple hover:text-purple-800 font-medium"
          >
            View all case studies
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              className="transition-transform group-hover:translate-x-1"
            >
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};
